module.exports = __webpack_public_path__ + "static/media/dow-purple.649047c8.svg";